import { tableConstants } from "./tableConstants";

const initialState = {
    configs: {}
};

export const tableReducer = (state = initialState, action) => {
    switch (action.type) {
        case tableConstants.SET_TABLE_CONFIG:
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.tableId]: action.payload.config
                }
            };
        
        case tableConstants.UPDATE_TABLE_CONFIG:
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.tableId]: {
                        ...state.configs[action.payload.tableId],
                        ...action.payload.config
                    }
                }
            };
        
        default:
            return state;
    }
}; 